import React from 'react';
import './Categories.css';

const CATEGORIES = [
  {
    label: 'School Student',
    key: 'school',
    sub: 'Individual training',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ),
  },
  {
    label: 'School Organisation',
    key: 'schoolorg',
    sub: 'Campus training',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <rect x="9" y="12" width="6" height="9"/>
      </svg>
    ),
  },
  {
    label: 'College Student',
    key: 'college',
    sub: 'Individual training',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
        <path d="M6 12v5c3 3 9 3 12 0v-5"/>
      </svg>
    ),
  },
  {
    label: 'College Organisation',
    key: 'collegeorg',
    sub: 'Campus training',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
        <rect x="3" y="10" width="18" height="11" rx="1"/>
        <path d="M3 10l9-7 9 7"/>
        <line x1="9" y1="21" x2="9" y2="14"/>
        <line x1="15" y1="21" x2="15" y2="14"/>
        <rect x="9" y="14" width="6" height="7"/>
      </svg>
    ),
  },
];

function Categories({ onSchoolStudent, onSchoolOrg, onCollegeStudent, onCollegeOrg, activeCategory, onCategoryChange }) {
  const handleClick = (cat) => {
    if (cat.key === 'school') onSchoolStudent();
    else if (cat.key === 'schoolorg') onSchoolOrg();
    else if (cat.key === 'college') onCollegeStudent();
    else if (cat.key === 'collegeorg') onCollegeOrg();
    else onCategoryChange(cat.key);
  };

  return (
    <div className="categories">
      {CATEGORIES.map((cat, i) => (
        <div
          key={i}
          className={`categories__card ${activeCategory === cat.key ? 'categories__card--active' : ''}`}
          onClick={() => handleClick(cat)}
        >
          <div className="categories__icon-box">
            {cat.icon}
          </div>
          <h3 className="categories__label">{cat.label}</h3>
          <p className="categories__sub">{cat.sub}</p>
          <button className="categories__btn">TAP TO EXPLORE</button>
        </div>
      ))}
    </div>
  );
}

export default Categories;